<template>
  <div
    :class="[
      'asc-no-data--container',
      fullSize ? 'asc-no-data--container--full-size' : null,
    ]"
  >
    <span class="asc-no-data--title">{{ getText }}</span>
  </div>
</template>

<script>
export default {
  name: 'AscNoData',

  props: {
    overrideText: {
      type: String,
      default: '',
    },
    fullSize: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    getText() {
      if (this.overrideText?.length) {
        return this.overrideText
      }

      return 'No Data Displayed'
    },
  },
}
</script>

<style lang="scss">
.asc-no-data--container {
  background-color: $primary-white;
  width: 100%;
  height: 80px;

  & .asc-no-data--title {
    display: block;
    position: relative;
    top: 40%;
    text-align: center;
  }
}

.asc-no-data--container--full-size {
  height: 240px;
}
</style>
